// extracted by mini-css-extract-plugin
module.exports = {"avatar":"styles_avatar__lyd_y","image":"styles_image__rRByF","indicatorWrapper":"styles_indicatorWrapper__CB2hA"};